import { PREMIUM_FEATURES } from "@common/flatRateBilling";
import { useAllowFeature } from "./useAllowFeature";
import { useTypedFlags } from "./useTypedFlags";

export function useCanUseRevenueRecognition(): boolean {
    const { schedules: isSchedulesFlagEnabled } = useTypedFlags();
    const { hasAccess: hasSchedulesPlan } = useAllowFeature(
        PREMIUM_FEATURES.SCHEDULES,
    );

    return isSchedulesFlagEnabled && hasSchedulesPlan;
}
